import React from 'react'
import { graphql } from 'gatsby'
import messages from '../messages/en'
import DetailsIndex from '../components/details/DetailsIndex'
import { Language } from '../Language'
import { FontsContext } from '../context'
import { fonts } from '../constants'

const DetailsTemplate = ({ pageContext: { ingredient }, data }: any) => {
  return (
    <FontsContext.Provider value={fonts.en}>
      <DetailsIndex
        ingredient={ingredient}
        data={data}
        messages={messages}
        language={Language.EN}
      />
    </FontsContext.Provider>
  )
}

export default DetailsTemplate

export const query = graphql`
  query($profileImg: String!, $whyAndHowImg: String!) {
    profile: file(relativePath: { eq: $profileImg }) {
      childImageSharp {
        fluid(maxWidth: 460, srcSetBreakpoints: [460]) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    whyAndHow: file(relativePath: { eq: $whyAndHowImg }) {
      childImageSharp {
        fluid(maxWidth: 834, srcSetBreakpoints: [460, 834]) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logo: file(relativePath: { eq: "shiseido_red.png" }) {
      childImageSharp {
        fluid(maxWidth: 185, srcSetBreakpoints: [185]) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`
